import { render, staticRenderFns } from "./promotions.vue?vue&type=template&id=042899f2&"
import script from "./promotions.vue?vue&type=script&lang=js&"
export * from "./promotions.vue?vue&type=script&lang=js&"
import style0 from "./promotions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042899f2')) {
      api.createRecord('042899f2', component.options)
    } else {
      api.reload('042899f2', component.options)
    }
    module.hot.accept("./promotions.vue?vue&type=template&id=042899f2&", function () {
      api.rerender('042899f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/account/promotions.vue"
export default component.exports